/* ============================================================
   MFF — FIX: homepage "What's your goal?" finder Add-to-Cart
   File: assets/mff-finder-fix.js  (included from layout/theme.liquid)

   Problem: the finder's mfhAddBundle / mfhAddMulti add items via
   /cart/add.js, then try to open the cart by clicking
   [aria-controls="CartDrawer"]. That element is the header cart link
   (<a is="magnet-link">, further modified by the B2B app), and a
   programmatic .click() does NOT trigger this theme's <cart-drawer>
   web component. Result: the item is added but there is no drawer or
   count feedback, so it looks like nothing happened.

   Fix: after a successful add, refresh the cart-drawer section via the
   Section Rendering API, update the <cart-count> badge from /cart.js,
   then call the drawer's native show(). These overrides replace the
   global functions the inline onclick handlers call.
   ============================================================ */
(function(){
  function mfhOpenCart(){
    return fetch('/cart.js',{cache:'no-store'}).then(function(r){return r.json();}).then(function(cart){
      document.querySelectorAll('cart-count').forEach(function(cc){
        cc.textContent=cart.item_count;
        cc.setAttribute('aria-label',cart.item_count+' items');
        if(cart.item_count>0){cc.removeAttribute('hidden');}else{cc.setAttribute('hidden','');}
      });
      return fetch('/?sections=cart-drawer',{cache:'no-store'}).then(function(r){return r.json();}).then(function(html){
        var drawer=document.querySelector('cart-drawer');
        if(drawer && html && html['cart-drawer']){
          var parsed=new DOMParser().parseFromString(html['cart-drawer'],'text/html');
          var fresh=parsed.querySelector('cart-drawer');
          if(fresh){drawer.innerHTML=fresh.innerHTML;}
          if(typeof drawer.show==='function'){drawer.show();return;}
        }
        var cb=document.querySelector('[aria-controls="CartDrawer"]');
        if(cb){cb.click();}else{window.location.href='/cart';}
      });
    }).catch(function(){window.location.href='/cart';});
  }
  function mfhAddBundle(event,btn){
    event.stopPropagation();
    var ref=btn.getAttribute('data-gs-ref');
    var sel=document.querySelector('[data-gs="'+ref+'"]');
    if(!sel||!sel.value)return;
    var origText=btn.textContent;
    btn.textContent='Adding…';btn.classList.add('adding');
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({id:parseInt(sel.value),quantity:1})})
      .then(function(r){if(!r.ok)throw new Error('add failed');return r.json();})
      .then(function(){btn.textContent='✓ Added!';setTimeout(function(){btn.textContent=origText;btn.classList.remove('adding');},2200);return mfhOpenCart();})
      .catch(function(){btn.textContent='Try again';btn.classList.remove('adding');});
  }
  function mfhAddMulti(event,btn){
    event.stopPropagation();
    var v1=btn.getAttribute('data-vid1');
    var v2=btn.getAttribute('data-vid2');
    var items=[{id:parseInt(v1),quantity:1}];
    if(v2)items.push({id:parseInt(v2),quantity:1});
    var origText=btn.textContent;
    btn.textContent='Adding…';btn.classList.add('adding');
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:items})})
      .then(function(r){if(!r.ok)throw new Error('add failed');return r.json();})
      .then(function(){btn.textContent=v2?'✓ Both added!':'✓ Added!';setTimeout(function(){btn.textContent=origText;btn.classList.remove('adding');},2200);return mfhOpenCart();})
      .catch(function(){btn.textContent='Try again';btn.classList.remove('adding');});
  }
  function apply(){window.mfhAddBundle=mfhAddBundle;window.mfhAddMulti=mfhAddMulti;window.mfhOpenCart=mfhOpenCart;}
  apply();
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',apply);}
  window.addEventListener('load',apply);
})();
